import { render, staticRenderFns } from "./WordGuess.vue?vue&type=template&id=1d499df0&scoped=true&"
import script from "./WordGuess.vue?vue&type=script&lang=js&"
export * from "./WordGuess.vue?vue&type=script&lang=js&"
import style0 from "./WordGuess.vue?vue&type=style&index=0&id=1d499df0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d499df0",
  null
  
)

export default component.exports